import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="API keys" hint="Per-tenant credential rotation." /> }
